import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import sels from 'sels';

import Modal from '@ott/modal';
import BigHeartIcon from '@ott/icon-big-heart';
import trackKm, { TrackData } from '../../helpers/trackKm';

import _getFp from 'lodash/fp/get';

export type FirstLikeModalProps = {
  hadSuccessfulLike: boolean;
  openAuth: () => void;
  // обновить, когда в auth появятся типы
  selectAuth?: (state: object) => any;
  trackData: TrackData;
};

const WAS_SHOWN_EARLIER_KEY = '@ott/activities-like:firstLikeModalWasShown';

export const defaultSelectAuth = _getFp('common.auth.data');

const checkIfWasShownEarlier = () => sels.get(WAS_SHOWN_EARLIER_KEY) === 'true';
const setWasShownEarlier = () => sels.set(WAS_SHOWN_EARLIER_KEY, true, { expires: '1m' });

const FirstLikeModal = ({
  hadSuccessfulLike,
  openAuth,
  selectAuth = defaultSelectAuth,
  trackData,
}: FirstLikeModalProps) => {
  const { auth: isAuthorized } = useSelector(selectAuth) || {};

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      trackKm.onFirstLikeModalShow(trackData);
    }
  }, [isOpen]);

  useEffect(() => {
    setIsOpen(hadSuccessfulLike && !checkIfWasShownEarlier() && !isAuthorized);
  }, [hadSuccessfulLike]); // кол-во зависимостей ограничено специально

  const closeModal = () => {
    setIsOpen(false);
    setWasShownEarlier();
  };

  const handleModalCloseByUser = () => {
    closeModal();
    trackKm.onFirstLikeModalClose(trackData);
  };

  const handleAuthClick = () => {
    closeModal();
    openAuth();
    trackKm.onFirstLikeModalAuthClick(trackData);
  };

  return (
    <Modal isOpen={isOpen} onClose={handleModalCloseByUser}>
      {{
        icon: <BigHeartIcon />,
        header: <>Экскурсия добавлена в&nbsp;избранное</>,
        body: <>Войдите в&nbsp;аккаунт, чтобы сохранить все&nbsp;понравившиеся экскурсии</>,
        primaryButton: {
          text: 'Войти',
          onClick: handleAuthClick,
          preventAutoClose: true,
        },
      }}
    </Modal>
  );
};

export default FirstLikeModal;
